import SquareLoader from "./square-loader";

type PleaseWaitProps = {
    title?: string,
    message: string,
    isInModal?: boolean
}

const PleaseWait = (props: PleaseWaitProps) => {
    const { title = "Please wait", message, isInModal = false } = props;

    const cssClassName = "please-wait " + (isInModal ? " in-modal" : "");

    return (
        <div className={cssClassName}>
            <SquareLoader />

            <h4>{title}</h4>

            <p>
                {message}
            </p>
        </div>
    );
}

export default PleaseWait;
